import getDataLayer from '../helpers/getDataLayer';
import IZdarzenieGTM from '../types/IZdarzenieGTM';

const rejestracjaZdarzeniaGTM = <T extends IZdarzenieGTM>(event: T): void => {
  if (!process.client) return;

  const dataLayer: unknown[] = getDataLayer();

  dataLayer.push(event);
};
export default rejestracjaZdarzeniaGTM;
